import {ResponseError} from "@/types";
import axios, {AxiosResponse} from "axios";

export const resolveError = (error: any, failed: (type: ResponseError, data: any) => void) => {
    if (axios.isAxiosError(error)) {
        const response = error.response as AxiosResponse;

        console.log(error);

        if(!response) {
            failed(ResponseError.Unknown, error);

            return;
        }

        if (response.status === 413) {
            failed(ResponseError.TooLarge, response.data);

            return;
        }

        if (response.status === 422) {
            failed(ResponseError.Validation, response.data);

            return;
        }

        if (response.status == 403) {
            failed(ResponseError.Unauthorized, response.data);

            return;
        }

        if (response.status == 401) {
            failed(ResponseError.Unauthorized, response.data);

            return;
        }

        if (response.status == 404) {
            failed(ResponseError.NotFound, response.data);

            return;
        }

        if(response.status === 500) {
            if(response.data && response.data.message) {
                failed(ResponseError.Internal, response.data);

                return;
            }
        }

        failed(ResponseError.Unknown, error);
    } else if (error instanceof Error) {
        failed(ResponseError.Unknown, error);
    }
}